import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

function Layout({ children }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/services', label: 'Ydelser' },
    { path: '/about', label: 'Om os' },
    { path: '/team', label: 'Teamet' },
  ];

  return (
    <>
      <nav className="nav">
        <div className="container nav__inner">
          <Link to="/" className="nav__logo">
            <img src="/core4it-logo.png" alt="Core4it" className="nav__logo-icon" />
            <span className="nav__logo-text">Core<span className="nav__logo-accent">4</span>it</span>
          </Link>

          <div className="nav__menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav__link ${location.pathname === link.path ? 'nav__link--active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact" className="nav__cta">
              Kontakt os
              <ArrowRight size={16} />
            </Link>
          </div>

          <button
            className="nav__toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation menu"
          >
            <span className="nav__toggle-line" />
            <span className="nav__toggle-line" />
            <span className="nav__toggle-line" />
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
          >
            {navLinks.map((link, index) => (
              <motion.div
                key={link.path}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Link to={link.path} className="mobile-menu__link">
                  {link.label}
                </Link>
              </motion.div>
            ))}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
            >
              <Link to="/contact" className="mobile-menu__link">
                Contact Us
              </Link>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <main>{children}</main>

      <Footer />
    </>
  );
}

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand-block">
          <div className="footer__brand">
            <img src="/core4it-logo.png" alt="" className="footer__icon" />
            <span>Core4it</span>
          </div>
          <p className="footer__address">
            Nordre Frihavnsgade 84<br />
            2100 København Ø
          </p>
          <p className="footer__cvr">CVR-nr.: 46251377</p>
        </div>
        <div className="footer__bottom">
          <p className="footer__copy">
            © {currentYear} Core4it. All rights reserved.
          </p>
          <Link to="/privatlivspolitik" className="footer__policy-link">
            Policy for processing of personal data
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Layout;
